module.exports = __webpack_public_path__ + "img/icon-hover-documentacion-pliego.b735ef94.svg";